import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  /** Member-only or transactional pages that should stay out of search results. */
  noIndex?: boolean;
}

export const SEOHead = ({
  title = "Swiftix — Your seat at the movies",
  description = "Discover, plan, gather, and remember. The full moviegoing experience — in one app.",

  image = "https://swiftix.app/og-image.png",
  url = "https://swiftix.app",
  type = "website",
  noIndex = false
}: SEOHeadProps) => {

  const fullTitle = title.includes("Swiftix") ? title : `${title} | Swiftix`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="keywords" content="movie recommendations, mood-based movies, movie discovery, watchlist, film finder, cinema" />
      <meta name="author" content="Swiftix" />
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};
